import React from 'react';
import { useRpcMediaAnyCoarsePointer, useRpcMediaSmallScreen } from '../components/hooks/useMatchMedia/useRpcMatchMedia';
const UiMediaQueryContext = /*#__PURE__*/ React.createContext({});
export const useMediaQuery = ()=>{
    return React.useContext(UiMediaQueryContext);
};
export const UiMediaQueryProvider = ({ children })=>{
    /**
   * We initialize these hooks in in a top-level provider instead of in each specific component
   * so that their value is computed as soon as possible when the applications is rendered.
   * Otherwise, animated components such as Dialog or Drawer wouldn't be animated
   * properly on the first render.
   */ const isSmallScreen = useRpcMediaSmallScreen();
    const isTouch = useRpcMediaAnyCoarsePointer();
    const context = React.useMemo(()=>({
            isSmallScreen,
            isTouch
        }), [
        isSmallScreen,
        isTouch
    ]);
    return /*#__PURE__*/ React.createElement(UiMediaQueryContext.Provider, {
        value: context
    }, children);
};

//# sourceMappingURL=UiMediaQueryProvider.js.map